import { render } from "./garment-up-close.vue?vue&type=template&id=07bafbe4&scoped=true"
import script from "./garment-up-close.vue?vue&type=script&lang=js"
export * from "./garment-up-close.vue?vue&type=script&lang=js"

import "./garment-up-close.vue?vue&type=style&index=0&id=07bafbe4&lang=css"
import "./garment-up-close.vue?vue&type=style&index=1&id=07bafbe4&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bafbe4"]])

export default __exports__